import { Pipe, PipeTransform, SecurityContext } from "@angular/core";
import { DomSanitizer, SafeHtml, SafeStyle, SafeUrl, SafeResourceUrl } from "@angular/platform-browser";
import DOMPurify from 'dompurify';
import { DOMPURIFY_RICH_CONFIG } from './ParsesafeHtml.pipe';

@Pipe({
  name: "safe"
})
export class SafePipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) {}

  public transform(value: any, type: string): SafeHtml | SafeStyle | SafeUrl | SafeResourceUrl | string {
    switch (type) {
      case "html":
        // Sanitize with DOMPurify before bypassing Angular's XSS protection. (CR-4, R1 H-10)
        return this.sanitizer.bypassSecurityTrustHtml(
          DOMPurify.sanitize(value, DOMPURIFY_RICH_CONFIG) as string
        );
      case "style":
        return this.sanitizer.bypassSecurityTrustStyle(value);
      // 'script' case intentionally removed — bypassSecurityTrustScript is never safe to use. (R2-10)
      case "url":
        return this.sanitizeOrBypassUrl(value, false);
      case "resourceUrl":
        return this.sanitizeOrBypassUrl(value, true);
      default:
        throw new Error(`Invalid safe type specified: ${type}`);
    }
  }

  private isAllowedUrl(value: any): boolean {
    if (!value || typeof value !== 'string') {
      return false;
    }
    const v = value.trim();
    if (/^javascript:/i.test(v)) {
      return false;
    }
    if (/^data:image\/svg\+xml/i.test(v)) {
      return false;
    }
    if (/^data:image\/(png|jpeg|jpg|gif|webp)/i.test(v)) {
      return true;
    }
    if (/^https:/i.test(v)) {
      return true;
    }
    if (/^blob:/i.test(v)) {
      return true;
    }
    return false;
  }

  private sanitizeOrBypassUrl(value: any, asResource: boolean): SafeUrl | SafeResourceUrl | string {
    if (this.isAllowedUrl(value)) {
      return asResource
        ? this.sanitizer.bypassSecurityTrustResourceUrl(value)
        : this.sanitizer.bypassSecurityTrustUrl(value);
    }
    return this.sanitizer.sanitize(SecurityContext.URL, value) || '';
  }
}
